import React from 'react'
import {ColConfig, Identifiable} from '@components/common/sandbox/list-view/types'
import {TwCell, TwInnerCell} from '../tw-components'

export interface CellProps<TData> {
  children: React.ReactNode,
  colConfig?: ColConfig<TData>
}

export const Cell = <TData extends Identifiable>(props: CellProps<TData>) => {
  const {
    children,
    colConfig
  } = props
  return <TwCell className={colConfig?.cellClassName}>
    <TwInnerCell>
      {children}
    </TwInnerCell>
  </TwCell>
}